export default __webpack_public_path__ + "static/media/tq-logo.6f87ce8e.svg";